"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Markdown;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _buildMarkdownParser = require("./buildMarkdownParser");
function Markdown(_ref) {
  let {
    markdown,
    onClick
  } = _ref;
  const md = (0, _buildMarkdownParser.buildMarkdownParser)();
  return /*#__PURE__*/_react.default.createElement(_styles.MarkdownContainer, {
    dangerouslySetInnerHTML: {
      __html: md.render(markdown.join('\n'))
    },
    onClick: onClick
  });
}
Markdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Markdown"
};